const basePath = '/pricing';

export const pricingRoutePaths = {
  root: basePath,
  variables: `${basePath}/variables`,
  counterpartyGroups: `${basePath}/groups`,
  counterpartyGroupDetail: `${basePath}/groups/:id`,
  defaultPriceList: `${basePath}/default`,
  customPriceLists: `${basePath}/lists`,
  customPriceListDetail: `${basePath}/lists/:id`,
} as const;
